import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { SicotService } from '../sicot.service';
import { QualificaReferentiOperatori } from '../types/QualificaReferentiOperatori';
import { QualificaRefOpDialogComponent } from './qualifica-ref-op-dialog/qualifica-ref-op-dialog.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-admin-qualifiche-referenti-operatori',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    HeaderComponent,
    FooterComponent,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
  ],
  templateUrl: './admin-qualifiche-referenti-operatori.component.html',
  styleUrl: './admin-qualifiche-referenti-operatori.component.css',
})
export class AdminQualificheReferentiOperatoriComponent implements OnInit {
  private readonly sicotService = inject(SicotService);
  private readonly dialog = inject(MatDialog);

  qualifiche: QualificaReferentiOperatori[] = [];
  caricamento = true;
  errore: string | null = null;
  displayedColumns: string[] = ['id', 'codice', 'descrizione', 'actions'];

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.caricamento = true;
    this.errore = null;
    this.sicotService.getQualificheRefOp().subscribe({
      next: (list) => {
        this.qualifiche = list ?? [];
        this.caricamento = false;
      },
      error: () => {
        this.errore = 'Errore nel caricamento delle qualifiche referenti/operatori.';
        this.caricamento = false;
      },
    });
  }

  aggiungi(): void {
    const ref = this.dialog.open(QualificaRefOpDialogComponent, {
      data: { qualifica: null },
      width: '420px',
    });
    ref.afterClosed().subscribe((result) => {
      if (result) this.loadList();
    });
  }

  modifica(q: QualificaReferentiOperatori): void {
    const ref = this.dialog.open(QualificaRefOpDialogComponent, {
      data: { qualifica: q },
      width: '420px',
    });
    ref.afterClosed().subscribe((result) => {
      if (result) this.loadList();
    });
  }

  elimina(q: QualificaReferentiOperatori): void {
    if (!confirm(`Eliminare la qualifica "${q.descrizione}" (id ${q.id})?`)) return;
    this.sicotService.deleteQualificaRefOp(q.id).subscribe({
      next: () => this.loadList(),
      error: () => {
        this.errore = 'Errore durante l\'eliminazione della qualifica.';
      },
    });
  }
}
